import {
  Box,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Logo from '../../../components/Logo/Logo';

/**
 * The backstory about S3G
 */
const Story = () => {
  const logoStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  };
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box paddingBottom="6em" paddingTop="6em">
      <Grid container sx={{ marginBottom: '3em' }} rowGap={5}>
        <Grid item xs={12} md={5.75} sx={logoStyle}>
          <Logo sizeEm={isMd ? 5 : 3.5} showText />
        </Grid>
        <Grid
          item
          xs={0}
          md={0.5}
          sx={{
            display: isMd ? 'flex' : 'none',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Divider orientation="vertical" variant="middle" />
        </Grid>
        <Grid item sx={logoStyle} xs={12} md={5.75}>
          <a
            href="https://www.alteracsoftware.com/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={`./alterac-software-logo-${theme.palette.mode}.png`}
              style={{ width: '100%', maxWidth: '450px' }}
            />
          </a>
        </Grid>
      </Grid>
      <Box>
        <Typography variant="h6" component="p" align="center">
          Backed by decades of real-world experience, we&apos;ve trained
          thousands to prepare for the unexpected. To deliver life-saving
          strategies for workplace violence and crisis response, Jim
          Warwick—veteran police officer and college professor—partnered with
          Corey Pritchard, founder of Alterac Software, a leading provider of
          innovative and scalable solutions. Together, they&apos;ve combined
          real-world expertise with cutting-edge technology to create engaging,
          accessible, and effective security training that empowers
          organizations to keep their people safe.
        </Typography>
      </Box>
    </Box>
  );
};

export default Story;
